var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };}import { Form, Field } from 'react-redux-form';
import { useNavigate } from 'react-router-dom';
import React from 'react';
import PropTypes from 'prop-types';
import rison from 'rison-node';
import { Icon } from "../../UI";
import { t } from "../../I18N";
import ModalTips from "../../App/ModalTips";
import { SearchTipsContent } from "../../App/SearchTipsContent";

const SearchBox = ({ placeholder, classname }) => {
  const navigate = useNavigate();

  const search = ({ searchTerm }) => {
    navigate(`/library/?q=${rison.encode({ searchTerm })}`);
  };

  return /*#__PURE__*/(
    _jsx("div", { className: `search-box ${classname}` }, void 0, /*#__PURE__*/
    _jsx(Form, { model: "library.search", onSubmit: search }, void 0, /*#__PURE__*/
    _jsx("div", { className: "input-group" }, void 0, /*#__PURE__*/
    _jsx("button", { type: "submit", className: "btn btn-primary" }, void 0, /*#__PURE__*/
    _jsx(Icon, { icon: "search" })
    ), /*#__PURE__*/
    _jsx(Field, { model: ".searchTerm" }, void 0, /*#__PURE__*/
    _jsx("input", { className: "form-control", type: "text", placeholder: placeholder })
    )
    )
    ), /*#__PURE__*/
    _jsx(ModalTips, {
      label: t('System', 'Search Tips', null, false),
      title: t('System', 'Narrow down your searches', null, false) }, void 0, /*#__PURE__*/

    _jsx(SearchTipsContent, {})
    )
    ));

};
SearchBox.defaultProps = {
  placeholder: '',
  classname: ''
};






export default SearchBox;